import { Avatar } from '@mui/material';
import { UserIcon } from 'react-line-awesome';

/**
 * The first letter of the first and the last word of a name: "Ayşe Yılmaz" is "AY", "marketingyusuf" is "M".
 * A name has no language of its own, so it is put in capitals in the interface's.
 */
const initialsOf = (name: string) => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  const first = Array.from(words[0])[0];
  const last = words.length > 1 ? Array.from(words[words.length - 1])[0] : '';
  return (first + last).toLocaleUpperCase(document.documentElement.lang);
};

/** A person, drawn alike wherever accounts are listed: a team's members, the user list, the user dialog. */
const UserAvatar = ({ name, size = 40 }: { name: string; size?: number }) => {
  const initials = initialsOf(name);
  return (
    <Avatar
      // The name stands beside it wherever it is drawn; the initials say nothing more.
      aria-hidden
      sx={{
        width: size,
        height: size,
        bgcolor: '#26272F',
        border: '1px solid rgb(54, 56, 67)',
        color: '#B5B7C8',
        fontSize: initials ? size * 0.38 : size * 0.5,
        fontWeight: 600,
      }}
    >
      {initials || <UserIcon />}
    </Avatar>
  );
};

export default UserAvatar;
